import {
    Autocomplete,
    AutocompleteItem,
    Button,
} from "@nextui-org/react"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,
    VirtualizeAutoComplete,
} from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_ACTYPE, ENUM_APP_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModValue, linksUrl } from "../../constants/enum"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useSelector } from "react-redux"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { useEffect, useMemo, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { calculateTotal } from "../../Utility/utility"
import { isMobile } from "react-device-detect"
import { useNavigate } from "react-router-dom"
import { setAcYearData } from "../../state/companySlice"
import { toast } from "react-toastify"


const SalesOrderSummary = () => {
    let { compCode, appType, startDate, endDate, compName } = useSelector((state) => state.company)
    let [selectedParty, setSelectedParty] = useState("")
    let [selectedItemType, setSelectedItemType] = useState("GRAY")
    let [selectedProduct, setSelectedProduct] = useState("")
    const inputRef = useRef(null)
    const navi = useNavigate()
    const [filterDate, setFilterDate] = useState({
        start: startDate,
        end: endDate,
    })
    const [acYearFDate, setAcYearFDate] = useState(startDate)
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };
    const { isLoading, isError: isErrorFetch, data: itemDetails = [] } = useFetchWithBody({
        url: apiRoute.salesorder.fetchMasterData,
        queryKey: "SalesMasterData",
        inputData: {
            compcode: compCode[0],//.join(","),
        }
    })

    const {
        isPending,
        isError,
        data = [],
        mutate: filterStock,
    } = usePost({
        url: apiRoute.stock.fetchYarnStock,
        queryKey: "YarnStock",
    })
    const funLoadData = (fromdate, todate, acyrdate) => {
        filterStock({
            data: {
                comp_code: compCode.join(","),
                from_date: dayjs(fromdate).format("YYYY-MM-DD"),
                to_date: dayjs(todate).format("YYYY-MM-DD"),
                acyear_date: dayjs(acyrdate).format("YYYY-MM-DD")
            },
        })
    }

    useEffect(() => {
        if (startDate && endDate)
            funLoadData(startDate, endDate, startDate)
    }, [startDate, endDate])

    const columns = [
        { header: "Item", accessor: "ITEM_DESC", type: "text", filterable: true, sortable: true, width: "150px", textcolor: "text-blue-700 font-semibold uppercase", isSticky: true },
        { header: "Category", accessor: "CAT", type: "text", filterable: true, sortable: true, },
        { header: "Open Wt.", accessor: "OPWGT", type: "number", filterable: true, sortable: true, align: "right" },
        { header: "Pur Wt", accessor: "PURWGT", type: "number", filterable: true, sortable: true, align: "right" },
        { header: "pur ret wt.", accessor: "PURRWGT", type: "number", filterable: true, sortable: true, align: "right", },
        { header: "Sale Wt.", accessor: "SALWGT", type: "number", filterable: true, sortable: true, align: "right", },
        { header: "sale Ret Wt.", accessor: "SALRWGT", type: "number", filterable: true, sortable: true, align: "right", },
        { header: "Cons Wt", accessor: "CONSWGT", type: "number", filterable: true, sortable: true, align: "right", },
        { header: "bal wt.", accessor: "BALWGHT", type: "number", filterable: true, sortable: true, align: "right", },

    ]

    const handleResetFilter = () => {
        setFilterDate({
            start: startDate,
            end: endDate,
        })
        setAcYearData(startDate)
        funLoadData(startDate, endDate, startDate)
    }

    const handleFilter = () => {
        if (!filterDate?.start || !filterDate?.end || !acYearFDate) {
            toast.error("All dates are  mandatory", {
                position: "top-center"
            });
            return;
        }



        const startDate = new Date(filterDate.start);
        const endDate = new Date(filterDate.end);
        
        if (isNaN(new Date(acYearFDate).getTime())) {
            toast.error("Invalid Ac Year Start date", {
                position: "top-center"
            });
            return;
        }
        if (isNaN(startDate.getTime())) {
            toast.error("Invalid from date", {
                position: "top-center"
            });
            return;
        }

        if (isNaN(endDate.getTime())) {
            toast.error("Invalid to date", {
                position: "top-center"
            });
            return;
        }

        if (startDate > endDate) {
            toast.error("Start date cannot be greater than end date", {
                position: "top-center"
            });
            return;
        }

        funLoadData(filterDate?.start, filterDate?.end, acYearFDate)
    }


    if (isPending) { return <LoadingCard /> }
    if (isError || isErrorFetch) { return <ErrorCard /> }
    return (
        <div>

            <MainContainer
                pageName="Yarn Stock"
                info={[]}
                breadcrumbs={["Reports & View ", "Yarn Stock"]}
            >

                <div className="flex flex-wrap mb-2 bg-gray-10 gap-2 shadow p-3">

                    {/* date */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {/* <DatePicker
                            label={"Ac Year Start Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            required
                            value={
                                acYearFDate ? dayjs(acYearFDate) : acYearFDate
                            }
                            onChange={(newValue) => {
                                setAcYearFDate(dayjs(newValue).format("YYYY-MM-DD"))

                            }}
                            slotProps={{ textField: { size: "small" } }}
                            sx={{ width: "145px" }}
                        /> */}
                        <DatePicker
                            label={"From Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                filterDate.start
                                    ? dayjs(filterDate.start)
                                    : filterDate.start
                            }
                            onChange={(newValue) => {
                                setFilterDate((prev) => {
                                    return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                                })
                            }}
                            sx={{ width: "145px" }}
                            slotProps={{ textField: { size: "small" } }}
                        />
                        <DatePicker
                            label={"To Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                filterDate.end ? dayjs(filterDate.end) : filterDate.end
                            }
                            onChange={(newValue) => {
                                setFilterDate((prev) => {
                                    return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                                })
                            }}
                            slotProps={{ textField: { size: "small" } }}
                            sx={{ width: "145px" }}
                        />


                    </LocalizationProvider>


                    <Button
                        color="danger"
                        size="sm"
                        startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                        onPress={handleFilter}

                    >
                        Search
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faFilter} />}
                        onPress={handleResetFilter}
                        className="bg-slate-700"
                    >
                        Reset
                    </Button>

                </div>

                <MasterGrid
                    columns={columns}
                    data={data}
                    className={""}
                    showPaging={false}
                    pageSize={20}
                    expandableRow={false}
                    virtualize={false}
                    headClass={"bg-slate-600 border-1 text-white border-slate-300 font-semibold"}
                    filterClass={"bg-white border-1 border-slate-300"}
                    footerClass={"bg-slate-600 text-white"}
                    style={{ border: "1px solid red" }}
                    exportHeader={{
                        companyName: compName.join(","),
                        reportName: `Yarn_Stock_Report _from ${formatDate(filterDate?.start)} to ${formatDate(filterDate?.end)} `,

                    }}
                    PdfExpLayout="portrait"
                    isExport={true}
                    minusCheckCol="BALWGHT"
                    onlyMinusColor={true}
                ></MasterGrid>

            </MainContainer>
        </div>
    )
}
export default SalesOrderSummary


